import { render, staticRenderFns } from "./ProjectCardToken2.vue?vue&type=template&id=0976675d&scoped=true&"
import script from "./ProjectCardToken2.vue?vue&type=script&lang=ts&"
export * from "./ProjectCardToken2.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCardToken2.vue?vue&type=style&index=0&id=0976675d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976675d",
  null
  
)

export default component.exports